import { Action, ActionType } from './actions';
import { PropostaState } from './types';

export const initialState: PropostaState = {
  proposta: {
    atendimento_id: 0,
    resumo: '',
    descricao: '',
    listagem_itens: '',
    prazo_entrega: 0,
    id: undefined,
  },
  propostas: [],
  propostaFinanceira: null,
  condicaoPagamento: null,
  propostasFinanceiras: [],
  enviarImagem: false,
  imagens: [],
  openFormPropostaFinanceira: false,
  propostaSalva: true,
  errosProposta: {
    resumo: undefined,
    descricao: undefined,
    listagem_itens: undefined,
    prazo_entrega: undefined,
    imagens: undefined,
  },
  errosPropostaFinanceira: {
    valor_proposta: undefined,
    desconto_em_porcentagem: undefined,
  },
  errosCondicaoPagamento: {
    valor_entrada: undefined,
    quantidade_parcela: undefined,
    desconto_entrada: undefined,
  },
};

export function propostaReducer(state: PropostaState, action: Action): PropostaState {
  switch (action.type) {
    case ActionType.SET_PROPOSTA:
      return {
        ...state,
        proposta: action.payload ? { ...state.proposta, ...action.payload } : initialState.proposta,
      };


    case ActionType.SET_FINANCEIRA:
      return {
        ...state,
        propostaFinanceira: action.payload ? { ...state.propostaFinanceira, ...action.payload } : null,
      };      

    case ActionType.SET_CONDICAO_PAGAMENTO:
      return {
        ...state,
        condicaoPagamento: action.payload
          ? { ...state.condicaoPagamento, ...action.payload }
          : null,
      };      

    case ActionType.RESET_ESTADO:
      return {
        ...state,
        proposta: {
          atendimento_id: state.proposta.atendimento_id,
          id: 0,
          resumo: '',
          descricao: '',
          listagem_itens: '',
          prazo_entrega: 0,
          estado_pagamento: undefined,
          PropostaFinanceiraAtivaId: undefined,
        },
        propostaFinanceira: null,
        condicaoPagamento: null,
        propostasFinanceiras: [],
        imagens: [],
        errosProposta: {},
        errosPropostaFinanceira: {},
        errosCondicaoPagamento: {},
        enviarImagem: false,
        openFormPropostaFinanceira: false,
        propostaSalva: false,
      };

    case ActionType.SET_PROPOSTAS:
      return {
        ...state,
        propostas: action.payload,
      }

    case ActionType.SET_PROPOSTAS_FINANCEIRAS:
      return {
        ...state,
        propostasFinanceiras: action.payload,
      }

    case ActionType.SET_ENVIAR_IMAGEM:
      return { ...state, enviarImagem: action.payload };

    case ActionType.SET_IMAGENS:
      return { ...state, imagens: action.payload };

    case ActionType.SET_OPEN_FORM_PROPOSTA_FINANCEIRA:
      return { ...state, openFormPropostaFinanceira: action.payload };

    case ActionType.SET_PROPOSTA_SALVA:
      return { ...state, propostaSalva: action.payload };

    case ActionType.SET_ERROS_PROPOSTA:
      return {
        ...state,
        errosProposta: {
          ...state.errosProposta,
          ...action.payload,
        },
      };           
    
    case ActionType.SET_ERROS_FINANCEIRA:
      return {
        ...state,
        errosPropostaFinanceira: {
          ...state.errosPropostaFinanceira,
          ...action.payload,
        },
      };

    case ActionType.SET_ERROS_CONDICAO_PAGAMENTO:
      return {
        ...state,
        errosCondicaoPagamento: {
          ...state.errosCondicaoPagamento,
          ...action.payload,
        },
      };


    default:
      return state;
  }
}
